// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { TrustDetailsCard_GrantorPrincipalFragment } from '../../../trusts/TrustDetails/graphql/TrustDetailsCard.fragments.generated';
import { TrustBeneficiariesList_BeneficiaryFragment } from '../../../trusts/TrustBeneficiariesList/graphql/TrustBeneficiariesList.fragments.generated';
import { TrustAdvisorsList_TrustAdvisorFragment } from '../../../trusts/TrustAdvisorsList/graphql/TrustAdvisorsList.fragments.generated';
import { TrustTrusteesList_SuccessorTrusteeFragment, TrustTrusteesList_TrusteeFragment } from '../../../trusts/TrustTrusteesList/graphql/TrustTrusteesList.fragments.generated';
import { AccountCurrentAssetValuationFragment, AssetValuationV2Fragment, AccountInitialAssetValuationFragment } from '../../../assetValuation/graphql/entityValuationQueries.generated';
import { GratPerformanceFragment } from '../../gratTrusts/graphql/GratTrust.generated';
import { ClientProfileBasicFragment } from '../../../clientProfiles/graphql/ClientProfile.generated';
import { PersonalAccountDetailsCard_OwnerPrincipalFragment, PersonalAccountDetailsCard_ControllingPartyFragment } from '../../../personalAccounts/PersonalAccountDetails/graphql/PersonalAccountDetailsCard.generated';
import { NonTrustCharitableEntityDetailsCard_DonorPrincipalFragment, NonTrustCharitableEntityDetailsCard_ControllingPartyFragment } from '../../../nonTrustCharitableEntities/NonTrustCharitableEntityDetails/graphql/NonTrustCharitableEntityDetailsCard.generated';
import { EntityValuationActions_EntityFragment } from '../EntityValuation/graphql/EntityValuation.generated';
import { Cashflows_CashflowFragment } from '../../../cashflows/CashflowDrawer/graphql/Cashflows.generated';
import { gql } from '@apollo/client';
import { TrustDetailsCard_GrantorPrincipalFragmentDoc } from '../../../trusts/TrustDetails/graphql/TrustDetailsCard.fragments.generated';
import { TrustBeneficiariesList_BeneficiaryFragmentDoc } from '../../../trusts/TrustBeneficiariesList/graphql/TrustBeneficiariesList.fragments.generated';
import { TrustAdvisorsList_TrustAdvisorFragmentDoc } from '../../../trusts/TrustAdvisorsList/graphql/TrustAdvisorsList.fragments.generated';
import { TrustTrusteesList_SuccessorTrusteeFragmentDoc, TrustTrusteesList_TrusteeFragmentDoc } from '../../../trusts/TrustTrusteesList/graphql/TrustTrusteesList.fragments.generated';
import { AccountCurrentAssetValuationFragmentDoc, AssetValuationV2FragmentDoc, AccountInitialAssetValuationFragmentDoc } from '../../../assetValuation/graphql/entityValuationQueries.generated';
import { GratPerformanceFragmentDoc } from '../../gratTrusts/graphql/GratTrust.generated';
import { ClientProfileBasicFragmentDoc } from '../../../clientProfiles/graphql/ClientProfile.generated';
import { PersonalAccountDetailsCard_OwnerPrincipalFragmentDoc, PersonalAccountDetailsCard_ControllingPartyFragmentDoc } from '../../../personalAccounts/PersonalAccountDetails/graphql/PersonalAccountDetailsCard.generated';
import { NonTrustCharitableEntityDetailsCard_DonorPrincipalFragmentDoc, NonTrustCharitableEntityDetailsCard_ControllingPartyFragmentDoc } from '../../../nonTrustCharitableEntities/NonTrustCharitableEntityDetails/graphql/NonTrustCharitableEntityDetailsCard.generated';
import { EntityValuationActions_EntityFragmentDoc } from '../EntityValuation/graphql/EntityValuation.generated';
import { Cashflows_CashflowFragmentDoc } from '../../../cashflows/CashflowDrawer/graphql/Cashflows.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityDetail_IrrevocableTrustFragment = { __typename?: 'IrrevocableTrust', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, trustJurisdictionStateCode?: string | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, mostRecentValuationDate?: Time | null, taxStatus?: Types.TrustTaxStatus | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & TrustDetailsCard_GrantorPrincipalFragment
  )> | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustAdvisorsList_TrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_SuccessorTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_TrusteeFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_RevocableTrustFragment = { __typename?: 'RevocableTrust', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, trustJurisdictionStateCode?: string | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, taxStatus?: Types.TrustTaxStatus | null, mostRecentValuationDate?: Time | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & TrustDetailsCard_GrantorPrincipalFragment
  )> | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustAdvisorsList_TrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_SuccessorTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_TrusteeFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_InsurancePolicyFragment = { __typename?: 'InsurancePolicy', id: string, nextPremiumDueDate?: Time | null, carrierName?: string | null, policyNumber?: string | null, kind: Types.InsurancePolicyKind, cashValue?: CurrencyUSD | null, cashValueDate?: Time | null, loanBalanceOutstanding?: CurrencyUSD | null, updatedAt: Time, deathBenefitAmount: CurrencyUSD, startDate?: Time | null, premiumAmount?: CurrencyUSD | null, premiumFrequency?: Types.InsurancePolicyPremiumFrequency | null, survivorship: boolean, notes?: string | null, termDurationYears?: number | null, conversionDate?: Time | null, policyHolders?: Array<{ __typename?: 'ClientProfile', id: string, displayName: string }> | null, documents?: Array<{ __typename?: 'Document', id: string }> | null };

export type EntityDetail_IlitTrustFragment = { __typename?: 'ILITTrust', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, trustJurisdictionStateCode?: string | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, mostRecentValuationDate?: Time | null, totalPolicyCashValue: CurrencyUSD, taxStatus?: Types.TrustTaxStatus | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & TrustDetailsCard_GrantorPrincipalFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustAdvisorsList_TrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_SuccessorTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_TrusteeFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null };

export type EntityDetail_GratTrustFragment = (
  { __typename?: 'GRATTrust', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, completionDate?: Time | null, termEndDate?: Time | null, taxableGift?: CurrencyUSD | null, termDurationYears?: number | null, officialInterestRatePercent?: Percent | null, downsideThresholdPercent?: Percent | null, upsideThresholdPercent?: Percent | null, description?: string | null, upsideThresholdValue?: CurrencyUSD | null, gstStatus?: Types.EntityGstStatus | null, trustJurisdictionStateCode?: string | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, mostRecentValuationDate?: Time | null, taxStatus?: Types.TrustTaxStatus | null, GRATTrustGrantor?: (
    { __typename?: 'Principal' }
    & TrustDetailsCard_GrantorPrincipalFragment
  ) | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustAdvisorsList_TrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_SuccessorTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_TrusteeFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null }
  & GratPerformanceFragment
);

export type EntityDetail_SlatTrustFragment = { __typename?: 'SLATTrust', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, trustJurisdictionStateCode?: string | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, mostRecentValuationDate?: Time | null, taxStatus?: Types.TrustTaxStatus | null, remainderBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, lifetimeBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, SLATTrustGrantor?: (
    { __typename?: 'Principal' }
    & TrustDetailsCard_GrantorPrincipalFragment
  ) | null, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustAdvisorsList_TrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_SuccessorTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_TrusteeFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account', id: string }
    & AccountInitialAssetValuationFragment
    & AccountCurrentAssetValuationFragment
  ) | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null };

export type EntityDetail_QprtTrustFragment = { __typename?: 'QPRTTrust', id: string, displayName: string, effectiveDate?: Time | null, termEndDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, trustJurisdictionStateCode?: string | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, officialInterestRatePercent?: Percent | null, termDurationYears?: number | null, taxableGift?: CurrencyUSD | null, mostRecentValuationDate?: Time | null, taxStatus?: Types.TrustTaxStatus | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & TrustDetailsCard_GrantorPrincipalFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustAdvisorsList_TrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_SuccessorTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_TrusteeFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_CltTrustFragment = { __typename?: 'CLTTrust', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, trustJurisdictionStateCode?: string | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, mostRecentValuationDate?: Time | null, charitableDeduction?: CurrencyUSD | null, termDurationLifetime: boolean, termDurationYears?: number | null, termEndDate?: Time | null, officialInterestRatePercent?: Percent | null, taxStatus?: Types.TrustTaxStatus | null, remainderBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, lifetimeBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & TrustDetailsCard_GrantorPrincipalFragment
  )> | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustAdvisorsList_TrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_SuccessorTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_TrusteeFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account', id: string }
    & AccountInitialAssetValuationFragment
    & AccountCurrentAssetValuationFragment
  ) | null };

export type EntityDetail_CrtTrustFragment = { __typename?: 'CRTTrust', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, trustJurisdictionStateCode?: string | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, mostRecentValuationDate?: Time | null, charitableDeduction?: CurrencyUSD | null, termDurationLifetime: boolean, termDurationYears?: number | null, termEndDate?: Time | null, officialInterestRatePercent?: Percent | null, taxStatus?: Types.TrustTaxStatus | null, remainderBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, lifetimeBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & TrustDetailsCard_GrantorPrincipalFragment
  )> | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustAdvisorsList_TrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_SuccessorTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_TrusteeFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account', id: string }
    & AccountInitialAssetValuationFragment
    & AccountCurrentAssetValuationFragment
  ) | null };

export type EntityDetail_IndividualPersonalAccountFragment = { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, stateInEstateStatus: Types.EntityInEstateStatus, mostRecentValuationDate?: Time | null, inEstateStatusRequired: Types.EntityInEstateStatus, nonTrustEntityTaxStatusRequired?: Types.NonTrustEntityTaxStatus | null, owner?: (
    { __typename?: 'Principal' }
    & PersonalAccountDetailsCard_OwnerPrincipalFragment
  ) | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & PersonalAccountDetailsCard_ControllingPartyFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_JointPersonalAccountFragment = { __typename?: 'JointPersonalAccount', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, mostRecentValuationDate?: Time | null, jointAccountType?: Types.JointPersonalAccountType | null, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null, owners?: Array<(
    { __typename?: 'Principal' }
    & PersonalAccountDetailsCard_OwnerPrincipalFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & PersonalAccountDetailsCard_ControllingPartyFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_RetirementPersonalAccountFragment = { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, stateInEstateStatus: Types.EntityInEstateStatus, mostRecentValuationDate?: Time | null, custodian?: string | null, inEstateStatusRequired: Types.EntityInEstateStatus, retirementAccountType?: Types.RetirementPersonalAccountType | null, nonTrustEntityTaxStatusRequired?: Types.NonTrustEntityTaxStatus | null, owner?: (
    { __typename?: 'Principal' }
    & PersonalAccountDetailsCard_OwnerPrincipalFragment
  ) | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & PersonalAccountDetailsCard_ControllingPartyFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_CustodialPersonalAccountFragment = { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, mostRecentValuationDate?: Time | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null, owner?: (
    { __typename?: 'Principal' }
    & PersonalAccountDetailsCard_OwnerPrincipalFragment
  ) | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & PersonalAccountDetailsCard_ControllingPartyFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_QualifiedTuitionPersonalAccountFragment = { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, mostRecentValuationDate?: Time | null, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null, owner?: (
    { __typename?: 'Principal' }
    & PersonalAccountDetailsCard_OwnerPrincipalFragment
  ) | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & PersonalAccountDetailsCard_ControllingPartyFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_DafFragment = { __typename?: 'DonorAdvisedFund', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, mostRecentValuationDate?: Time | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null, donors?: Array<(
    { __typename?: 'Principal' }
    & NonTrustCharitableEntityDetailsCard_DonorPrincipalFragment
  )> | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & NonTrustCharitableEntityDetailsCard_ControllingPartyFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_PrivateFoundationFragment = { __typename?: 'PrivateFoundation', id: string, displayName: string, effectiveDate?: Time | null, legalName?: string | null, description?: string | null, gstStatus?: Types.EntityGstStatus | null, mostRecentValuationDate?: Time | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null, donors?: Array<(
    { __typename?: 'Principal' }
    & NonTrustCharitableEntityDetailsCard_DonorPrincipalFragment
  )> | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & NonTrustCharitableEntityDetailsCard_ControllingPartyFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type BusinessEntityDetailsCard_KeyPersonFragment = { __typename?: 'KeyPerson', id: string, roles?: Array<{ __typename?: 'KeyPersonRole', id: string, kind?: Types.KeyPersonRoleKind | null }> | null, individual?: (
    { __typename?: 'ClientProfile', id: string }
    & ClientProfileBasicFragment
  ) | null, entity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null };

export type EntityDetail_BusinessEntity_CCorpBusinessEntity_Fragment = { __typename?: 'CCorpBusinessEntity', id: string, displayName: string, effectiveDate?: Time | null, currentValue: CurrencyUSD, legalName?: string | null, description?: string | null, mostRecentValuationDate?: Time | null, doingBusinessAsName?: string | null, taxID?: string | null, formationJurisdictionStateCode?: string | null, keyPeopleNotes?: string | null, ownershipAsOfDate?: Time | null, grantorControlledPercentage: Percent, grantorControlledDiscountedValue: CurrencyUSD, grantorControlledValue: CurrencyUSD, nongrantorControlledPercentage: Percent, nongrantorControlledValue: CurrencyUSD, requiresCtaReporting?: boolean | null, finCenID?: string | null, businessEntityTaxStatus?: Types.BusinessEntityTaxStatus | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, mostRecentValuation?: (
    { __typename?: 'AssetValuationV2', id: string }
    & AssetValuationV2Fragment
  ) | null, keyPeople?: Array<(
    { __typename?: 'KeyPerson' }
    & BusinessEntityDetailsCard_KeyPersonFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_BusinessEntity_GpBusinessEntity_Fragment = { __typename?: 'GPBusinessEntity', id: string, displayName: string, effectiveDate?: Time | null, currentValue: CurrencyUSD, legalName?: string | null, description?: string | null, mostRecentValuationDate?: Time | null, doingBusinessAsName?: string | null, taxID?: string | null, formationJurisdictionStateCode?: string | null, keyPeopleNotes?: string | null, ownershipAsOfDate?: Time | null, grantorControlledPercentage: Percent, grantorControlledDiscountedValue: CurrencyUSD, grantorControlledValue: CurrencyUSD, nongrantorControlledPercentage: Percent, nongrantorControlledValue: CurrencyUSD, requiresCtaReporting?: boolean | null, finCenID?: string | null, businessEntityTaxStatus?: Types.BusinessEntityTaxStatus | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, mostRecentValuation?: (
    { __typename?: 'AssetValuationV2', id: string }
    & AssetValuationV2Fragment
  ) | null, keyPeople?: Array<(
    { __typename?: 'KeyPerson' }
    & BusinessEntityDetailsCard_KeyPersonFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_BusinessEntity_LlcBusinessEntity_Fragment = { __typename?: 'LLCBusinessEntity', id: string, displayName: string, effectiveDate?: Time | null, currentValue: CurrencyUSD, legalName?: string | null, description?: string | null, mostRecentValuationDate?: Time | null, doingBusinessAsName?: string | null, taxID?: string | null, formationJurisdictionStateCode?: string | null, keyPeopleNotes?: string | null, ownershipAsOfDate?: Time | null, grantorControlledPercentage: Percent, grantorControlledDiscountedValue: CurrencyUSD, grantorControlledValue: CurrencyUSD, nongrantorControlledPercentage: Percent, nongrantorControlledValue: CurrencyUSD, requiresCtaReporting?: boolean | null, finCenID?: string | null, businessEntityTaxStatus?: Types.BusinessEntityTaxStatus | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, mostRecentValuation?: (
    { __typename?: 'AssetValuationV2', id: string }
    & AssetValuationV2Fragment
  ) | null, keyPeople?: Array<(
    { __typename?: 'KeyPerson' }
    & BusinessEntityDetailsCard_KeyPersonFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_BusinessEntity_LpBusinessEntity_Fragment = { __typename?: 'LPBusinessEntity', id: string, displayName: string, effectiveDate?: Time | null, currentValue: CurrencyUSD, legalName?: string | null, description?: string | null, mostRecentValuationDate?: Time | null, doingBusinessAsName?: string | null, taxID?: string | null, formationJurisdictionStateCode?: string | null, keyPeopleNotes?: string | null, ownershipAsOfDate?: Time | null, grantorControlledPercentage: Percent, grantorControlledDiscountedValue: CurrencyUSD, grantorControlledValue: CurrencyUSD, nongrantorControlledPercentage: Percent, nongrantorControlledValue: CurrencyUSD, requiresCtaReporting?: boolean | null, finCenID?: string | null, businessEntityTaxStatus?: Types.BusinessEntityTaxStatus | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, mostRecentValuation?: (
    { __typename?: 'AssetValuationV2', id: string }
    & AssetValuationV2Fragment
  ) | null, keyPeople?: Array<(
    { __typename?: 'KeyPerson' }
    & BusinessEntityDetailsCard_KeyPersonFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_BusinessEntity_SCorpBusinessEntity_Fragment = { __typename?: 'SCorpBusinessEntity', id: string, displayName: string, effectiveDate?: Time | null, currentValue: CurrencyUSD, legalName?: string | null, description?: string | null, mostRecentValuationDate?: Time | null, doingBusinessAsName?: string | null, taxID?: string | null, formationJurisdictionStateCode?: string | null, keyPeopleNotes?: string | null, ownershipAsOfDate?: Time | null, grantorControlledPercentage: Percent, grantorControlledDiscountedValue: CurrencyUSD, grantorControlledValue: CurrencyUSD, nongrantorControlledPercentage: Percent, nongrantorControlledValue: CurrencyUSD, requiresCtaReporting?: boolean | null, finCenID?: string | null, businessEntityTaxStatus?: Types.BusinessEntityTaxStatus | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, mostRecentValuation?: (
    { __typename?: 'AssetValuationV2', id: string }
    & AssetValuationV2Fragment
  ) | null, keyPeople?: Array<(
    { __typename?: 'KeyPerson' }
    & BusinessEntityDetailsCard_KeyPersonFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_BusinessEntity_SoleProprietorshipBusinessEntity_Fragment = { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, effectiveDate?: Time | null, currentValue: CurrencyUSD, legalName?: string | null, description?: string | null, mostRecentValuationDate?: Time | null, doingBusinessAsName?: string | null, taxID?: string | null, formationJurisdictionStateCode?: string | null, keyPeopleNotes?: string | null, ownershipAsOfDate?: Time | null, grantorControlledPercentage: Percent, grantorControlledDiscountedValue: CurrencyUSD, grantorControlledValue: CurrencyUSD, nongrantorControlledPercentage: Percent, nongrantorControlledValue: CurrencyUSD, requiresCtaReporting?: boolean | null, finCenID?: string | null, businessEntityTaxStatus?: Types.BusinessEntityTaxStatus | null, mostRecentValuation?: (
    { __typename?: 'AssetValuationV2', id: string }
    & AssetValuationV2Fragment
  ) | null, keyPeople?: Array<(
    { __typename?: 'KeyPerson' }
    & BusinessEntityDetailsCard_KeyPersonFragment
  )> | null, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null };

export type EntityDetail_BusinessEntityFragment = EntityDetail_BusinessEntity_CCorpBusinessEntity_Fragment | EntityDetail_BusinessEntity_GpBusinessEntity_Fragment | EntityDetail_BusinessEntity_LlcBusinessEntity_Fragment | EntityDetail_BusinessEntity_LpBusinessEntity_Fragment | EntityDetail_BusinessEntity_SCorpBusinessEntity_Fragment | EntityDetail_BusinessEntity_SoleProprietorshipBusinessEntity_Fragment;

export type EntityDetail_InsurancePersonalAccountFragment = { __typename?: 'InsurancePersonalAccount', id: string, displayName: string, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, gstStatus?: Types.EntityGstStatus | null, legalName?: string | null, description?: string | null, currentValue: CurrencyUSD, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, totalPolicyCashValue: CurrencyUSD, designerAccount?: (
    { __typename?: 'Account' }
    & AccountCurrentAssetValuationFragment
    & AccountInitialAssetValuationFragment
  ) | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & EntityDetail_InsurancePolicyFragment
  )> | null, owners?: Array<(
    { __typename?: 'Principal' }
    & PersonalAccountDetailsCard_OwnerPrincipalFragment
  )> | null };

export type EntityDetail_OwnedByStakeFragment = { __typename?: 'OwnershipStake', id: string, isGrantorControlled: boolean, ownershipPercentage?: Percent | null, owningIndividual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, owningEntity?: { __typename?: 'Entity', id: string, household: { __typename?: 'Household', id: string }, subtype: { __typename?: 'CCorpBusinessEntity', grantorControlledPercentage: Percent, id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', grantorControlledPercentage: Percent, id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', grantorControlledPercentage: Percent, id: string, displayName: string } | { __typename?: 'LPBusinessEntity', grantorControlledPercentage: Percent, id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', grantorControlledPercentage: Percent, id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', grantorControlledPercentage: Percent, id: string, displayName: string } } | null };

export type EntityDetail_OwnerOfStakeFragment = { __typename?: 'OwnershipStake', id: string, ownershipPercentage?: Percent | null, ownedValue: CurrencyUSD, ownedEntity?: { __typename?: 'Entity', id: string, integrationEntities?: Array<{ __typename?: 'IntegrationEntity', id: string, kind: Types.IntegrationEntityKind, name: string }> | null, subtype: { __typename?: 'CCorpBusinessEntity', grantorControlledDiscountedValue: CurrencyUSD, id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'CLTTrust', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'CRTTrust', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'GPBusinessEntity', grantorControlledDiscountedValue: CurrencyUSD, id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'GRATTrust', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'ILITTrust', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'IrrevocableTrust', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'JointPersonalAccount', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'LLCBusinessEntity', grantorControlledDiscountedValue: CurrencyUSD, id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'LPBusinessEntity', grantorControlledDiscountedValue: CurrencyUSD, id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'PrivateFoundation', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'QPRTTrust', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'RevocableTrust', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'SCorpBusinessEntity', grantorControlledDiscountedValue: CurrencyUSD, id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'SLATTrust', id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } | { __typename?: 'SoleProprietorshipBusinessEntity', grantorControlledDiscountedValue: CurrencyUSD, id: string, displayName: string, mostRecentValuationDate?: Time | null, currentDiscountedValue: CurrencyUSD, effectiveDiscountPercent: Percent } } | null };

export type EntityDetail_IntegrationEntityFragment = { __typename?: 'IntegrationEntity', id: string, kind: Types.IntegrationEntityKind, name: string };

export type EntityDetail_LiabilityFragment = { __typename?: 'Liability', id: string, displayName: string, currentAmount?: CurrencyUSD | null, currentAmountAsOfDate?: Time | null };

export type EntityDetail_DeathOrderNoteFragment = { __typename?: 'EntityNotes', id: string, notes: string, updatedAt: Time, clientProfile?: { __typename?: 'ClientProfile', id: string, firstName: string, lastName: string, displayName: string } | null, user: { __typename?: 'User', id: string, displayName: string } };

export type EntityDetail_EntityFragment = (
  { __typename?: 'Entity', extendedDisplayKind: string, id: string, kind: Types.EntityKind, stage: Types.EntityStage, syncDeathOrderNotes: boolean, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, document: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType } } | null } | null> | null }, integrationEntities?: Array<(
    { __typename?: 'IntegrationEntity' }
    & EntityDetail_IntegrationEntityFragment
  )> | null, household: { __typename?: 'Household', id: string, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, displayName: string }> }, ownedByStakes?: Array<(
    { __typename?: 'OwnershipStake' }
    & EntityDetail_OwnedByStakeFragment
  )> | null, ownedOwnershipStakes?: Array<(
    { __typename?: 'OwnershipStake' }
    & EntityDetail_OwnerOfStakeFragment
  )> | null, liabilitiesOwed: { __typename?: 'LiabilityConnection', edges?: Array<{ __typename?: 'LiabilityEdge', node?: (
        { __typename?: 'Liability' }
        & EntityDetail_LiabilityFragment
      ) | null } | null> | null }, liabilitiesLent: { __typename?: 'LiabilityConnection', edges?: Array<{ __typename?: 'LiabilityEdge', node?: (
        { __typename?: 'Liability' }
        & EntityDetail_LiabilityFragment
      ) | null } | null> | null }, cashflows: { __typename?: 'CashflowConnection', edges?: Array<{ __typename?: 'CashflowEdge', node?: (
        { __typename?: 'Cashflow' }
        & Cashflows_CashflowFragment
      ) | null } | null> | null }, subtype: (
    { __typename?: 'CCorpBusinessEntity', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_BusinessEntity_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTTrust', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_CltTrustFragment
  ) | (
    { __typename?: 'CRTTrust', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_CrtTrustFragment
  ) | (
    { __typename?: 'CustodialPersonalAccount', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_CustodialPersonalAccountFragment
  ) | (
    { __typename?: 'DonorAdvisedFund', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_DafFragment
  ) | (
    { __typename?: 'GPBusinessEntity', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_BusinessEntity_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATTrust', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_GratTrustFragment
  ) | (
    { __typename?: 'ILITTrust', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_IlitTrustFragment
  ) | (
    { __typename?: 'IndividualPersonalAccount', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_IndividualPersonalAccountFragment
  ) | (
    { __typename?: 'InsurancePersonalAccount', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_InsurancePersonalAccountFragment
  ) | (
    { __typename?: 'IrrevocableTrust', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_IrrevocableTrustFragment
  ) | (
    { __typename?: 'JointPersonalAccount', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_JointPersonalAccountFragment
  ) | (
    { __typename?: 'LLCBusinessEntity', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_BusinessEntity_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_BusinessEntity_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'PrivateFoundation', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_PrivateFoundationFragment
  ) | (
    { __typename?: 'QPRTTrust', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_QprtTrustFragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_QualifiedTuitionPersonalAccountFragment
  ) | (
    { __typename?: 'RetirementPersonalAccount', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_RetirementPersonalAccountFragment
  ) | (
    { __typename?: 'RevocableTrust', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_RevocableTrustFragment
  ) | (
    { __typename?: 'SCorpBusinessEntity', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_BusinessEntity_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_SlatTrustFragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity', currentValue: CurrencyUSD, currentDiscountedValue: CurrencyUSD, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent }
    & EntityDetail_BusinessEntity_SoleProprietorshipBusinessEntity_Fragment
  ), deathOrderNotes?: Array<(
    { __typename?: 'EntityNotes' }
    & EntityDetail_DeathOrderNoteFragment
  )> | null }
  & EntityValuationActions_EntityFragment
);

export type EntityDetailsQueryVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
}>;


export type EntityDetailsQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & EntityDetail_EntityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    EntityDetails: 'EntityDetails' as const
  },
  Fragment: {
    EntityDetail_IrrevocableTrust: 'EntityDetail_IrrevocableTrust' as const,
    EntityDetail_RevocableTrust: 'EntityDetail_RevocableTrust' as const,
    EntityDetail_InsurancePolicy: 'EntityDetail_InsurancePolicy' as const,
    EntityDetail_ILITTrust: 'EntityDetail_ILITTrust' as const,
    EntityDetail_GRATTrust: 'EntityDetail_GRATTrust' as const,
    EntityDetail_SLATTrust: 'EntityDetail_SLATTrust' as const,
    EntityDetail_QPRTTrust: 'EntityDetail_QPRTTrust' as const,
    EntityDetail_CLTTrust: 'EntityDetail_CLTTrust' as const,
    EntityDetail_CRTTrust: 'EntityDetail_CRTTrust' as const,
    EntityDetail_IndividualPersonalAccount: 'EntityDetail_IndividualPersonalAccount' as const,
    EntityDetail_JointPersonalAccount: 'EntityDetail_JointPersonalAccount' as const,
    EntityDetail_RetirementPersonalAccount: 'EntityDetail_RetirementPersonalAccount' as const,
    EntityDetail_CustodialPersonalAccount: 'EntityDetail_CustodialPersonalAccount' as const,
    EntityDetail_QualifiedTuitionPersonalAccount: 'EntityDetail_QualifiedTuitionPersonalAccount' as const,
    EntityDetail_DAF: 'EntityDetail_DAF' as const,
    EntityDetail_PrivateFoundation: 'EntityDetail_PrivateFoundation' as const,
    BusinessEntityDetailsCard_KeyPerson: 'BusinessEntityDetailsCard_KeyPerson' as const,
    EntityDetail_BusinessEntity: 'EntityDetail_BusinessEntity' as const,
    EntityDetail_InsurancePersonalAccount: 'EntityDetail_InsurancePersonalAccount' as const,
    EntityDetail_OwnedByStake: 'EntityDetail_OwnedByStake' as const,
    EntityDetail_OwnerOfStake: 'EntityDetail_OwnerOfStake' as const,
    EntityDetail_IntegrationEntity: 'EntityDetail_IntegrationEntity' as const,
    EntityDetail_Liability: 'EntityDetail_Liability' as const,
    EntityDetail_DeathOrderNote: 'EntityDetail_DeathOrderNote' as const,
    EntityDetail_Entity: 'EntityDetail_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntityDetail_IntegrationEntityFragmentDoc = gql`
    fragment EntityDetail_IntegrationEntity on IntegrationEntity {
  id
  kind
  name
}
    `;
export const EntityDetail_OwnedByStakeFragmentDoc = gql`
    fragment EntityDetail_OwnedByStake on OwnershipStake {
  id
  isGrantorControlled
  ownershipPercentage
  owningIndividual {
    id
    displayName
  }
  owningEntity {
    id
    household {
      id
    }
    subtype {
      id
      displayName
      ... on BusinessEntity {
        grantorControlledPercentage
      }
    }
  }
}
    `;
export const EntityDetail_OwnerOfStakeFragmentDoc = gql`
    fragment EntityDetail_OwnerOfStake on OwnershipStake {
  id
  ownershipPercentage
  ownedValue
  ownedEntity {
    id
    integrationEntities {
      id
      kind
      name
    }
    subtype {
      id
      displayName
      mostRecentValuationDate
      currentDiscountedValue
      effectiveDiscountPercent
      ... on BusinessEntity {
        grantorControlledDiscountedValue
      }
    }
  }
}
    `;
export const EntityDetail_LiabilityFragmentDoc = gql`
    fragment EntityDetail_Liability on Liability {
  id
  displayName
  currentAmount
  currentAmountAsOfDate
}
    `;
export const EntityDetail_InsurancePolicyFragmentDoc = gql`
    fragment EntityDetail_InsurancePolicy on InsurancePolicy {
  id
  nextPremiumDueDate
  carrierName
  policyNumber
  kind
  policyHolders {
    id
    displayName
  }
  cashValue
  cashValueDate
  loanBalanceOutstanding
  updatedAt
  deathBenefitAmount
  startDate
  premiumAmount
  premiumFrequency
  survivorship
  notes
  termDurationYears
  documents {
    id
  }
  conversionDate
}
    `;
export const EntityDetail_IrrevocableTrustFragmentDoc = gql`
    fragment EntityDetail_IrrevocableTrust on IrrevocableTrust {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  trustJurisdictionStateCode
  inEstateStatus
  stateInEstateStatus
  mostRecentValuationDate
  grantors {
    ...TrustDetailsCard_GrantorPrincipal
  }
  policies {
    ...EntityDetail_InsurancePolicy
  }
  taxStatus
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  trustAdvisors {
    ...TrustAdvisorsList_TrustAdvisor
  }
  successorTrustees {
    ...TrustTrusteesList_SuccessorTrustee
  }
  trustees {
    ...TrustTrusteesList_Trustee
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
}
    ${TrustDetailsCard_GrantorPrincipalFragmentDoc}
${EntityDetail_InsurancePolicyFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${TrustAdvisorsList_TrustAdvisorFragmentDoc}
${TrustTrusteesList_SuccessorTrusteeFragmentDoc}
${TrustTrusteesList_TrusteeFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}`;
export const EntityDetail_RevocableTrustFragmentDoc = gql`
    fragment EntityDetail_RevocableTrust on RevocableTrust {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  trustJurisdictionStateCode
  inEstateStatus
  stateInEstateStatus
  taxStatus
  mostRecentValuationDate
  grantors {
    ...TrustDetailsCard_GrantorPrincipal
  }
  policies {
    ...EntityDetail_InsurancePolicy
  }
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  trustAdvisors {
    ...TrustAdvisorsList_TrustAdvisor
  }
  successorTrustees {
    ...TrustTrusteesList_SuccessorTrustee
  }
  trustees {
    ...TrustTrusteesList_Trustee
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
}
    ${TrustDetailsCard_GrantorPrincipalFragmentDoc}
${EntityDetail_InsurancePolicyFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${TrustAdvisorsList_TrustAdvisorFragmentDoc}
${TrustTrusteesList_SuccessorTrusteeFragmentDoc}
${TrustTrusteesList_TrusteeFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}`;
export const EntityDetail_SlatTrustFragmentDoc = gql`
    fragment EntityDetail_SLATTrust on SLATTrust {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  trustJurisdictionStateCode
  inEstateStatus
  stateInEstateStatus
  mostRecentValuationDate
  remainderBeneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  taxStatus
  lifetimeBeneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  SLATTrustGrantor: grantor {
    ...TrustDetailsCard_GrantorPrincipal
  }
  trustAdvisors {
    ...TrustAdvisorsList_TrustAdvisor
  }
  successorTrustees {
    ...TrustTrusteesList_SuccessorTrustee
  }
  trustees {
    ...TrustTrusteesList_Trustee
  }
  designerAccount {
    ...AccountInitialAssetValuation
    id
    ...AccountCurrentAssetValuation
  }
  policies {
    ...EntityDetail_InsurancePolicy
  }
}
    ${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${TrustDetailsCard_GrantorPrincipalFragmentDoc}
${TrustAdvisorsList_TrustAdvisorFragmentDoc}
${TrustTrusteesList_SuccessorTrusteeFragmentDoc}
${TrustTrusteesList_TrusteeFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${EntityDetail_InsurancePolicyFragmentDoc}`;
export const EntityDetail_IlitTrustFragmentDoc = gql`
    fragment EntityDetail_ILITTrust on ILITTrust {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  trustJurisdictionStateCode
  inEstateStatus
  stateInEstateStatus
  mostRecentValuationDate
  totalPolicyCashValue
  grantors {
    ...TrustDetailsCard_GrantorPrincipal
  }
  taxStatus
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  trustAdvisors {
    ...TrustAdvisorsList_TrustAdvisor
  }
  successorTrustees {
    ...TrustTrusteesList_SuccessorTrustee
  }
  trustees {
    ...TrustTrusteesList_Trustee
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
  policies {
    ...EntityDetail_InsurancePolicy
  }
}
    ${TrustDetailsCard_GrantorPrincipalFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${TrustAdvisorsList_TrustAdvisorFragmentDoc}
${TrustTrusteesList_SuccessorTrusteeFragmentDoc}
${TrustTrusteesList_TrusteeFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}
${EntityDetail_InsurancePolicyFragmentDoc}`;
export const EntityDetail_GratTrustFragmentDoc = gql`
    fragment EntityDetail_GRATTrust on GRATTrust {
  id
  displayName
  effectiveDate
  legalName
  completionDate
  termEndDate
  taxableGift
  termDurationYears
  officialInterestRatePercent
  downsideThresholdPercent
  upsideThresholdPercent
  description
  upsideThresholdValue
  gstStatus
  trustJurisdictionStateCode
  inEstateStatus
  stateInEstateStatus
  mostRecentValuationDate
  GRATTrustGrantor: grantor {
    ...TrustDetailsCard_GrantorPrincipal
  }
  taxStatus
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  trustAdvisors {
    ...TrustAdvisorsList_TrustAdvisor
  }
  successorTrustees {
    ...TrustTrusteesList_SuccessorTrustee
  }
  trustees {
    ...TrustTrusteesList_Trustee
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
  ...GratPerformance
}
    ${TrustDetailsCard_GrantorPrincipalFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${TrustAdvisorsList_TrustAdvisorFragmentDoc}
${TrustTrusteesList_SuccessorTrusteeFragmentDoc}
${TrustTrusteesList_TrusteeFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}
${GratPerformanceFragmentDoc}`;
export const EntityDetail_QprtTrustFragmentDoc = gql`
    fragment EntityDetail_QPRTTrust on QPRTTrust {
  id
  displayName
  effectiveDate
  termEndDate
  legalName
  description
  gstStatus
  trustJurisdictionStateCode
  inEstateStatus
  stateInEstateStatus
  officialInterestRatePercent
  termDurationYears
  taxableGift
  mostRecentValuationDate
  grantors {
    ...TrustDetailsCard_GrantorPrincipal
  }
  taxStatus
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  trustAdvisors {
    ...TrustAdvisorsList_TrustAdvisor
  }
  successorTrustees {
    ...TrustTrusteesList_SuccessorTrustee
  }
  trustees {
    ...TrustTrusteesList_Trustee
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
}
    ${TrustDetailsCard_GrantorPrincipalFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${TrustAdvisorsList_TrustAdvisorFragmentDoc}
${TrustTrusteesList_SuccessorTrusteeFragmentDoc}
${TrustTrusteesList_TrusteeFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}`;
export const EntityDetail_IndividualPersonalAccountFragmentDoc = gql`
    fragment EntityDetail_IndividualPersonalAccount on IndividualPersonalAccount {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  inEstateStatusRequired: inEstateStatus
  stateInEstateStatus
  mostRecentValuationDate
  nonTrustEntityTaxStatusRequired: taxStatus
  owner {
    ...PersonalAccountDetailsCard_OwnerPrincipal
  }
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  controllingParties {
    ...PersonalAccountDetailsCard_ControllingParty
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
}
    ${PersonalAccountDetailsCard_OwnerPrincipalFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${PersonalAccountDetailsCard_ControllingPartyFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}`;
export const EntityDetail_JointPersonalAccountFragmentDoc = gql`
    fragment EntityDetail_JointPersonalAccount on JointPersonalAccount {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  inEstateStatus
  stateInEstateStatus
  mostRecentValuationDate
  jointAccountType: type
  nonTrustEntityTaxStatus: taxStatus
  owners {
    ...PersonalAccountDetailsCard_OwnerPrincipal
  }
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  controllingParties {
    ...PersonalAccountDetailsCard_ControllingParty
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
}
    ${PersonalAccountDetailsCard_OwnerPrincipalFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${PersonalAccountDetailsCard_ControllingPartyFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}`;
export const EntityDetail_RetirementPersonalAccountFragmentDoc = gql`
    fragment EntityDetail_RetirementPersonalAccount on RetirementPersonalAccount {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  inEstateStatusRequired: inEstateStatus
  stateInEstateStatus
  mostRecentValuationDate
  retirementAccountType: type
  custodian
  nonTrustEntityTaxStatusRequired: taxStatus
  owner {
    ...PersonalAccountDetailsCard_OwnerPrincipal
  }
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  controllingParties {
    ...PersonalAccountDetailsCard_ControllingParty
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
}
    ${PersonalAccountDetailsCard_OwnerPrincipalFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${PersonalAccountDetailsCard_ControllingPartyFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}`;
export const EntityDetail_CustodialPersonalAccountFragmentDoc = gql`
    fragment EntityDetail_CustodialPersonalAccount on CustodialPersonalAccount {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  mostRecentValuationDate
  inEstateStatus
  stateInEstateStatus
  nonTrustEntityTaxStatus: taxStatus
  owner {
    ...PersonalAccountDetailsCard_OwnerPrincipal
  }
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  controllingParties {
    ...PersonalAccountDetailsCard_ControllingParty
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
}
    ${PersonalAccountDetailsCard_OwnerPrincipalFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${PersonalAccountDetailsCard_ControllingPartyFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}`;
export const EntityDetail_QualifiedTuitionPersonalAccountFragmentDoc = gql`
    fragment EntityDetail_QualifiedTuitionPersonalAccount on QualifiedTuitionPersonalAccount {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  inEstateStatus
  stateInEstateStatus
  mostRecentValuationDate
  nonTrustEntityTaxStatus: taxStatus
  owner {
    ...PersonalAccountDetailsCard_OwnerPrincipal
  }
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  controllingParties {
    ...PersonalAccountDetailsCard_ControllingParty
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
}
    ${PersonalAccountDetailsCard_OwnerPrincipalFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${PersonalAccountDetailsCard_ControllingPartyFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}`;
export const EntityDetail_CltTrustFragmentDoc = gql`
    fragment EntityDetail_CLTTrust on CLTTrust {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  trustJurisdictionStateCode
  inEstateStatus
  stateInEstateStatus
  mostRecentValuationDate
  charitableDeduction
  termDurationLifetime
  termDurationYears
  termEndDate
  officialInterestRatePercent
  remainderBeneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  taxStatus
  lifetimeBeneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  grantors {
    ...TrustDetailsCard_GrantorPrincipal
  }
  policies {
    ...EntityDetail_InsurancePolicy
  }
  trustAdvisors {
    ...TrustAdvisorsList_TrustAdvisor
  }
  successorTrustees {
    ...TrustTrusteesList_SuccessorTrustee
  }
  trustees {
    ...TrustTrusteesList_Trustee
  }
  designerAccount {
    ...AccountInitialAssetValuation
    id
    ...AccountCurrentAssetValuation
  }
}
    ${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${TrustDetailsCard_GrantorPrincipalFragmentDoc}
${EntityDetail_InsurancePolicyFragmentDoc}
${TrustAdvisorsList_TrustAdvisorFragmentDoc}
${TrustTrusteesList_SuccessorTrusteeFragmentDoc}
${TrustTrusteesList_TrusteeFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}`;
export const EntityDetail_CrtTrustFragmentDoc = gql`
    fragment EntityDetail_CRTTrust on CRTTrust {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  trustJurisdictionStateCode
  inEstateStatus
  stateInEstateStatus
  mostRecentValuationDate
  charitableDeduction
  termDurationLifetime
  termDurationYears
  termEndDate
  officialInterestRatePercent
  remainderBeneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  taxStatus
  lifetimeBeneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  grantors {
    ...TrustDetailsCard_GrantorPrincipal
  }
  policies {
    ...EntityDetail_InsurancePolicy
  }
  trustAdvisors {
    ...TrustAdvisorsList_TrustAdvisor
  }
  successorTrustees {
    ...TrustTrusteesList_SuccessorTrustee
  }
  trustees {
    ...TrustTrusteesList_Trustee
  }
  designerAccount {
    ...AccountInitialAssetValuation
    id
    ...AccountCurrentAssetValuation
  }
}
    ${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${TrustDetailsCard_GrantorPrincipalFragmentDoc}
${EntityDetail_InsurancePolicyFragmentDoc}
${TrustAdvisorsList_TrustAdvisorFragmentDoc}
${TrustTrusteesList_SuccessorTrusteeFragmentDoc}
${TrustTrusteesList_TrusteeFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}`;
export const EntityDetail_DafFragmentDoc = gql`
    fragment EntityDetail_DAF on DonorAdvisedFund {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  mostRecentValuationDate
  inEstateStatus
  stateInEstateStatus
  nonTrustEntityTaxStatus: taxStatus
  donors {
    ...NonTrustCharitableEntityDetailsCard_DonorPrincipal
  }
  policies {
    ...EntityDetail_InsurancePolicy
  }
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  controllingParties {
    ...NonTrustCharitableEntityDetailsCard_ControllingParty
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
}
    ${NonTrustCharitableEntityDetailsCard_DonorPrincipalFragmentDoc}
${EntityDetail_InsurancePolicyFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${NonTrustCharitableEntityDetailsCard_ControllingPartyFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}`;
export const EntityDetail_PrivateFoundationFragmentDoc = gql`
    fragment EntityDetail_PrivateFoundation on PrivateFoundation {
  id
  displayName
  effectiveDate
  legalName
  description
  gstStatus
  mostRecentValuationDate
  inEstateStatus
  stateInEstateStatus
  nonTrustEntityTaxStatus: taxStatus
  donors {
    ...NonTrustCharitableEntityDetailsCard_DonorPrincipal
  }
  policies {
    ...EntityDetail_InsurancePolicy
  }
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  controllingParties {
    ...NonTrustCharitableEntityDetailsCard_ControllingParty
  }
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
}
    ${NonTrustCharitableEntityDetailsCard_DonorPrincipalFragmentDoc}
${EntityDetail_InsurancePolicyFragmentDoc}
${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${NonTrustCharitableEntityDetailsCard_ControllingPartyFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}`;
export const BusinessEntityDetailsCard_KeyPersonFragmentDoc = gql`
    fragment BusinessEntityDetailsCard_KeyPerson on KeyPerson {
  id
  roles {
    id
    kind
  }
  individual {
    id
    ...ClientProfileBasic
  }
  entity {
    id
    subtype {
      id
      displayName
    }
  }
  organization {
    id
    name
  }
}
    ${ClientProfileBasicFragmentDoc}`;
export const EntityDetail_BusinessEntityFragmentDoc = gql`
    fragment EntityDetail_BusinessEntity on BusinessEntity {
  id
  displayName
  effectiveDate
  currentValue
  legalName
  description
  mostRecentValuationDate
  mostRecentValuation {
    id
    ...AssetValuationV2
  }
  doingBusinessAsName
  taxID
  formationJurisdictionStateCode
  keyPeopleNotes
  keyPeople {
    ...BusinessEntityDetailsCard_KeyPerson
  }
  ownershipAsOfDate
  businessEntityTaxStatus: taxStatus
  grantorControlledPercentage
  grantorControlledDiscountedValue
  grantorControlledValue
  nongrantorControlledPercentage
  nongrantorControlledValue
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
  requiresCtaReporting
  finCenID
  ... on CCorpBusinessEntity {
    policies {
      ...EntityDetail_InsurancePolicy
    }
  }
  ... on SCorpBusinessEntity {
    policies {
      ...EntityDetail_InsurancePolicy
    }
  }
  ... on GPBusinessEntity {
    policies {
      ...EntityDetail_InsurancePolicy
    }
  }
  ... on LPBusinessEntity {
    policies {
      ...EntityDetail_InsurancePolicy
    }
  }
  ... on LLCBusinessEntity {
    policies {
      ...EntityDetail_InsurancePolicy
    }
  }
}
    ${AssetValuationV2FragmentDoc}
${BusinessEntityDetailsCard_KeyPersonFragmentDoc}
${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}
${EntityDetail_InsurancePolicyFragmentDoc}`;
export const EntityDetail_InsurancePersonalAccountFragmentDoc = gql`
    fragment EntityDetail_InsurancePersonalAccount on InsurancePersonalAccount {
  id
  displayName
  mostRecentValuationDate
  effectiveDate
  assetSummaryDisplay
  designerAccount {
    ...AccountCurrentAssetValuation
    ...AccountInitialAssetValuation
  }
  policies {
    ...EntityDetail_InsurancePolicy
  }
  gstStatus
  legalName
  description
  owners {
    ...PersonalAccountDetailsCard_OwnerPrincipal
  }
  currentValue
  inEstateStatus
  stateInEstateStatus
  totalPolicyCashValue
}
    ${AccountCurrentAssetValuationFragmentDoc}
${AccountInitialAssetValuationFragmentDoc}
${EntityDetail_InsurancePolicyFragmentDoc}
${PersonalAccountDetailsCard_OwnerPrincipalFragmentDoc}`;
export const EntityDetail_DeathOrderNoteFragmentDoc = gql`
    fragment EntityDetail_DeathOrderNote on EntityNotes {
  id
  clientProfile {
    id
    firstName
    lastName
    displayName
  }
  notes
  user {
    id
    displayName
  }
  updatedAt
}
    `;
export const EntityDetail_EntityFragmentDoc = gql`
    fragment EntityDetail_Entity on Entity {
  ...EntityValuationActions_Entity
  entityDocumentRelationships {
    edges {
      node {
        id
        relationshipType
        document {
          id
          name
          type
        }
      }
    }
  }
  extendedDisplayKind
  integrationEntities {
    ...EntityDetail_IntegrationEntity
  }
  id
  kind
  household {
    id
    possiblePrimaryClients {
      id
      displayName
    }
  }
  stage
  ownedByStakes {
    ...EntityDetail_OwnedByStake
  }
  ownedOwnershipStakes {
    ...EntityDetail_OwnerOfStake
  }
  liabilitiesOwed {
    edges {
      node {
        ...EntityDetail_Liability
      }
    }
  }
  liabilitiesLent {
    edges {
      node {
        ...EntityDetail_Liability
      }
    }
  }
  cashflows {
    edges {
      node {
        ...Cashflows_Cashflow
      }
    }
  }
  syncDeathOrderNotes
  subtype {
    ... on EntitySubtype {
      currentValue
      currentDiscountedValue
      taxDiscount
      effectiveDiscountPercent
    }
    ...EntityDetail_IrrevocableTrust
    ...EntityDetail_RevocableTrust
    ...EntityDetail_SLATTrust
    ...EntityDetail_ILITTrust
    ...EntityDetail_GRATTrust
    ...EntityDetail_QPRTTrust
    ...EntityDetail_IndividualPersonalAccount
    ...EntityDetail_JointPersonalAccount
    ...EntityDetail_RetirementPersonalAccount
    ...EntityDetail_CustodialPersonalAccount
    ...EntityDetail_QualifiedTuitionPersonalAccount
    ...EntityDetail_CLTTrust
    ...EntityDetail_CRTTrust
    ...EntityDetail_DAF
    ...EntityDetail_PrivateFoundation
    ...EntityDetail_BusinessEntity
    ...EntityDetail_InsurancePersonalAccount
  }
  deathOrderNotes {
    ...EntityDetail_DeathOrderNote
  }
}
    ${EntityValuationActions_EntityFragmentDoc}
${EntityDetail_IntegrationEntityFragmentDoc}
${EntityDetail_OwnedByStakeFragmentDoc}
${EntityDetail_OwnerOfStakeFragmentDoc}
${EntityDetail_LiabilityFragmentDoc}
${Cashflows_CashflowFragmentDoc}
${EntityDetail_IrrevocableTrustFragmentDoc}
${EntityDetail_RevocableTrustFragmentDoc}
${EntityDetail_SlatTrustFragmentDoc}
${EntityDetail_IlitTrustFragmentDoc}
${EntityDetail_GratTrustFragmentDoc}
${EntityDetail_QprtTrustFragmentDoc}
${EntityDetail_IndividualPersonalAccountFragmentDoc}
${EntityDetail_JointPersonalAccountFragmentDoc}
${EntityDetail_RetirementPersonalAccountFragmentDoc}
${EntityDetail_CustodialPersonalAccountFragmentDoc}
${EntityDetail_QualifiedTuitionPersonalAccountFragmentDoc}
${EntityDetail_CltTrustFragmentDoc}
${EntityDetail_CrtTrustFragmentDoc}
${EntityDetail_DafFragmentDoc}
${EntityDetail_PrivateFoundationFragmentDoc}
${EntityDetail_BusinessEntityFragmentDoc}
${EntityDetail_InsurancePersonalAccountFragmentDoc}
${EntityDetail_DeathOrderNoteFragmentDoc}`;
export const EntityDetailsDocument = gql`
    query EntityDetails($entityId: ID!) {
  entities(where: {id: $entityId}) {
    edges {
      node {
        ...EntityDetail_Entity
      }
    }
  }
}
    ${EntityDetail_EntityFragmentDoc}`;

/**
 * __useEntityDetailsQuery__
 *
 * To run a query within a React component, call `useEntityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDetailsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useEntityDetailsQuery(baseOptions: Apollo.QueryHookOptions<EntityDetailsQuery, EntityDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityDetailsQuery, EntityDetailsQueryVariables>(EntityDetailsDocument, withFetchPolicyContext(options));
      }
export function useEntityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityDetailsQuery, EntityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityDetailsQuery, EntityDetailsQueryVariables>(EntityDetailsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEntityDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityDetailsQuery, EntityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityDetailsQuery, EntityDetailsQueryVariables>(EntityDetailsDocument, withFetchPolicyContext(options));
        }
export type EntityDetailsQueryHookResult = ReturnType<typeof useEntityDetailsQuery>;
export type EntityDetailsLazyQueryHookResult = ReturnType<typeof useEntityDetailsLazyQuery>;
export type EntityDetailsSuspenseQueryHookResult = ReturnType<typeof useEntityDetailsSuspenseQuery>;
export type EntityDetailsQueryResult = Apollo.QueryResult<EntityDetailsQuery, EntityDetailsQueryVariables>;